import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import * as NavConstants from 'constants/NavConstants';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as Colors from 'ui-library/Colors';
import SectionTabs from 'ui-library/SectionTabs';

interface ProjectsAndTemplatesSectionProps {
  currentSection: NavConstants.SidepanelSection | null;
  onSectionReset?: (section: NavConstants.Section) => void;
}

/**
 * This component is responsible for creating the tabs in the ProjectsSidepanel. The tabs are only enabled if
 * the ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE is set to true. When it is set to false, then nothing will be
 * rendered.
 */
export function ProjectsAndTemplatesSectionTabs(props: ProjectsAndTemplatesSectionProps): JSX.Element | null {
  if (!BenchlingConfig.ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE) {
    return null;
  }

  const handleClick = (section: NavConstants.Section): void => {
    SidepanelActions.openSection(section);
  };

  const handleActiveClick = (section: NavConstants.Section): void => {
    props.onSectionReset?.(section);
  };

  const tabs = [
    {
      handleClick: () => {
        handleClick(NavConstants.Section.PROJECTS);
      },
      handleActiveClick: () => {
        handleActiveClick(NavConstants.Section.PROJECTS);
      },
      ariaControls: `${NavConstants.Section.PROJECTS}_PANEL`,
      id: `${NavConstants.Section.PROJECTS}_TAB`,
      isActive: props.currentSection !== NavConstants.Section.TEMPLATE_COLLECTIONS,
      text: 'Projects',
      dataTestAttrs: {component: 'SectionTab', element: 'navItem', key: 'projects'},
    },
    {
      handleClick: () => {
        handleClick(NavConstants.Section.TEMPLATE_COLLECTIONS);
      },
      handleActiveClick: () => {
        handleActiveClick(NavConstants.Section.TEMPLATE_COLLECTIONS);
      },
      ariaControls: `${NavConstants.Section.TEMPLATE_COLLECTIONS}_PANEL`,
      id: `${NavConstants.Section.TEMPLATE_COLLECTIONS}_TAB`,
      isActive: props.currentSection === NavConstants.Section.TEMPLATE_COLLECTIONS,
      text: 'Template Collections',
      dataTestAttrs: {component: 'SectionTab', element: 'navItem', key: 'template-collections'},
    },
  ];
  return <SectionTabs className={css(styles.sectionTabs)} tabs={tabs} />;
}

const styles = StyleSheet.create({
  sectionTabs: {
    borderBottomColor: Colors.GRAY,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    margin: '0 -12px',
  },
});
